'use strict';

/*!
 * tokai today recent events custom block js
 *
 * @package tokai-univ
 */
const $ = jQuery;

/*!
 * @deps jquery
 */

const dateContent = $( '.js-date-content' );

$( window ).on( 'load', function () {
	dateContent.each( function () {
		if ( $( this ).is( '[aria-hidden="false"]' ) ) {
			$( this ).css( 'display', 'block' );
		}
	} );
} );

const slideSpeed = 200;
let targetDay;
$( '.js-date-select' ).on( 'click keypress', function () {
	targetDay = '#' + $( this ).attr( 'aria-controls' );
	//this item status
	$( '.js-date-select' ).parent( 'li' ).removeClass( 'wp-block-tokai-recent-events__date-item--current' );
	$( this ).parent( 'li' ).addClass( 'wp-block-tokai-recent-events__date-item--current' );
	//date item
	dateContent.slideUp( slideSpeed );
	dateContent.attr( 'aria-hidden', 'true' );
	$( targetDay ).slideDown( slideSpeed );
	$( targetDay ).attr( 'aria-hidden', 'false' );
	return false;
} );

